import React from 'react';
import meImage from '../assets/aboutme.png';
import aboutMeVid from '../assets/aboutmevid.mp4';

function About() {
    const handleProjectsClick = () => {
        document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' });
    };

    const handleResumeClick = () => {
        document.getElementById('resume')?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <section id="about" className="about-section">
            <div className="about-container">
                {/* Text Content */}
                <div className="about-content">
                    <h2 className="about-title">About Me</h2>
                    <p className="about-tagline">
                        Third-year Computer Engineering Student | FAITH Colleges
                    </p>

                    <div className="about-layout-grid">
                        {/* LEFT: Text & Buttons */}
                        <div className="about-left-col">
                            <div className="about-intro">
                                <p className="about-paragraph">
                                    Hello! My name is Arabella Nipay Resaba. I am a third-year Computer Engineering student at FAITH Colleges, Batangas. My journey in engineering is driven by a deep curiosity for how things work—finding purpose in bridging the invisible logic of software with the tactile complexity of hardware to create efficient, real-world solutions.
                                </p>
                                <p className="about-paragraph">
                                    Currently, I'm focusing my academic energy on:
                                </p>
                                <ul className="about-skills-list">
                                    <li><strong>Full-Stack Development</strong>: Crafting intuitive digital experiences.</li>
                                    <li><strong>Embedded Systems</strong>: Interfacing digital logic with the physical world.</li>
                                    <li><strong>Problem Solving</strong>: Approaching challenges with a collaborative mindset.</li>
                                </ul>
                                <p className="about-paragraph">
                                    Beyond my core studies, I am passionate about IoT and smart home automation. I believe engineering is a creative community effort, and through constant learning, I aim to build systems that simplify and enrich the lives of others.
                                </p>
                            </div>

                            {/* CTA Buttons */}
                            <div className="about-cta">
                                <button className="cta-btn cta-primary" onClick={handleProjectsClick}>
                                    View My Projects
                                </button>
                                <button className="cta-btn cta-secondary" onClick={handleResumeClick}>
                                    Download Resume
                                </button>
                            </div>
                        </div>

                        {/* MIDDLE: Photo */}
                        <div className="about-middle-col">
                            <img src={meImage} alt="Arabella Nipay Resaba" className="about-photo" />
                        </div>

                        {/* RIGHT: Cards */}
                        <div className="about-right-col">
                            <div className="about-cards-wrapper">
                                {/* My Career Vision Card */}
                                <div className="about-card">
                                    <h3 className="card-title">My Career Vision</h3>
                                    <p className="card-text">
                                        I aspire to become a successful Computer Engineer who applies knowledge and skills to build impactful applications and systems.
                                    </p>
                                </div>

                                {/* My Strengths Card */}
                                <div className="about-card">
                                    <h3 className="card-title">My Strengths</h3>
                                    <ul className="card-list">
                                        <li>Hardworking and dedicated</li>
                                        <li>Strong problem-solving skills</li>
                                        <li>Collaborative mindset</li>
                                        <li>Continuous learner</li>
                                    </ul>
                                </div>
                            </div>

                            {/* Video */}
                            <div className="about-video-container">
                                <video 
                                    src={aboutMeVid} 
                                    loop 
                                    muted 
                                    playsInline 
                                    className="about-video"
                                    onMouseEnter={(e) => e.target.play()}
                                    onMouseLeave={(e) => {
                                        e.target.pause();
                                    }}
                                />
                                <div className="video-hover-hint">
                                    <span>Hover to Play</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About;
